import { Skeleton, SkeletonProps } from "shared/components";
import { Icon, Text } from "@ttc3k/trekker";
import { SunLight } from "iconoir-react";
import { useTranslation } from "react-i18next";

export const LoadingPage = ({ ...props }: SkeletonProps) => {
  const { t } = useTranslation();

  return (
    <Skeleton size={"fullPage"} {...props}>
      <Icon
        size={"xl"}
        Element={SunLight}
        color={"icon.highlight.light"}
        animation={"spinScale 2s infinite"}
        animationTimingFunction={"standard.expressive"}
      />
      <Text visual={"bodyMedium"} color={"text.mid"}>
        {t("core:LOADING_PAGE")}
      </Text>
    </Skeleton>
  );
};
